<script setup lang="ts">
interface Props {
  selector?: string
}

const props = withDefaults(
  defineProps<Props>(),
  {
    selector: '',
  },
)

const toc = ref<{
  link: {
    hash: string
  }
  label: string
}[]>([])

onMounted(() => {
  const matches = document.querySelectorAll(`${props.selector} h2`)
  if (matches.length >= 2) {
    matches.forEach((match) => {
      if (match.textContent && match.id) {
        toc.value.push({
          link: { hash: match.id },
          label: match.textContent,
        })
      }
    })
  }
})
</script>

<template>
  <div
    v-if="toc.length >= 2"
    class="prose lg:prose-xl mx-auto px-4"
  >
    <h2>{{ $t('table_of_content_title') }}</h2>
    <div class="not-prose">
      <ul>
        <li
          v-for="(item, index) in toc"
          :key="index"
          class="text-peacock-500 list-inside list-disc"
        >
          <a
            :href="`#${item.link.hash}`"
            :data-id="item.link.hash"
            class="!inline"
          >
            {{ item.label }}
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>
